<template>
  <div class="setting-whirl">
    <!-- 旋转方向 -->
    <div class="direction">
      <div class="direction__title">
        旋转方向
      </div>
      <ul class="radios__list">
        <li class="radios__item" 
        :class="{active: item.active}" 
        v-for="(item, key) in directionList" 
        :key="key"
        @click.stop="changeCCW($event, item, key)">
          <i></i>
          <span>{{item.text}}</span>
        </li>
      </ul>
    </div>
    <!-- 旋转速度 -->
    <div class="speed">
      <div class="speed__title">
        旋转速度
      </div>
      <div class="speed__content">
        <div class="slider">
          <div class="slider-before">慢</div>
          <div class="rc-slider">
            <div class="rc-slider-rail">
              <div class="content-box" v-for="i in 8" :style="{left: i * 100 / 9 + '%'}"></div>
            </div>
            <div v-dragHandle class="rc-slider-handle" :style="{'left':  (speed-speedRange[0])/(speedRange[1]-speedRange[0])*100 + '%'}"></div>
          </div>
          <div class="slider-after">快</div>
        </div>
      </div>
    </div>
    <!-- 旋转中心设置 -->
    <div class="center">
      <!-- <div class="center__title">
        旋转中心设置
      </div> -->
      <div class="center__content">
        Tips:请在画布中设置旋转中心,
        动画属性设置实时应用
        <!-- <div class="dom-content" v-html="contentHTML" :style="contentStyle"></div>
        <div class="handle" :style="contentStyle" @click="changeCenter">
          <div class="little" :style="littleStyle"></div>
        </div> -->
      </div>
    </div>
    <div class="footer-play">
      <div @click="playStayAnim"><i class="preview-play"></i>预览动画</div>
      <div @click="cancleStayAnim"><i class="delete-stay"></i>无动画</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props:['sprite'],
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectSprites_Msg'
    ]),
    contentStyle() {
      const style = {};
      style.width = this.matrix.width + 'px';
      style.height = this.matrix.height + 'px';
      style.top = this.matrix.top + 'px';
      style.left = this.matrix.left + 'px';
      return style;
    },
    littleStyle() {
      const style = {};
      style.top = `calc(${this.position.top * 100}% - 5px)`;
      style.left = `calc(${this.position.left * 100}% - 5px)`;
      return style;
    }
  },
  data () {
    return {
      ANALYSIS: {category:'rotate_animation_panel', action:'click_close_panel', label:'旋转动画面板-关闭面板'},
      ccw: false,
      speed: 1.05,
      position: {
        top: 0,
        left: 0
      },
      speedRange: [0.05, 2.3],
      spriteBox: null,
      hasWhirl: false,
      change: false,
      isShow: false,
      directionList: [
        {type: false, text: '顺时针', active: true},
        {type: true, text: '逆时针', active: false}
      ]
    }
  },
  mounted () {
    this.$bus.on('effectSetting.whirl', data => {
      if(data.state === 'in') {
        this.initData()
      }else if(data.state === 'out') {
        this.closePoint(true);
      }
    })
    this.$bus.on('undoRedoHandle', this._undoRedoHandle)
    this.$bus.on('output_points', this._outputPoints)
  },
  methods: {
    initData() {
      if(this.sprite) {
        this.isShow = true;
        this.$store.commit('toggle_isPreventDefault', false);
        let stayAnim = Object.assign({}, this.sprite.effect.stayAnim);
        if(stayAnim.type !== 'Whirl') {
          this.hasWhirl = false;
          this.speed = 1.05;
          this.ccw = false;
          this.position.top = .5;
          this.position.left = .5;
          this.change = true;
          this.updateEffect()
        } else {
          this.change = false;
          this.hasWhirl = true;
          this.speed = stayAnim.speed;
          this.ccw = stayAnim.ccw;
          this.position.top = stayAnim.position.top;
          this.position.left = stayAnim.position.left;
        }
        this.directionList.forEach((val, k) => {
          val.active = false;
          this.ccw === val.type && (val.active = true);
        })
        this.$bus.emit('take_points', {
          type: 'open',
          data: {
            top: this.position.top,
            left: this.position.left
          }
        })
      } else {
        this.isShow = false;
      }
    },
    dragMouseup() {
      this.change = true;
      this.speed = Math.round(this.speed * 100) / 100;
      this.$analysis({
        category: 'rotate_animation_panel', 
        action: 'drag_ratate_speed_' + this.speed, 
        label: '旋转动画面板_速度_' + this.speed
      })
    },
    changeCenter(e) {
      if(e.target.className === 'little') return;
      this.position.top = e.offsetY / this.matrix.height
      this.position.left = e.offsetX / this.matrix.width
      this.change = true;
    },
    changeCCW(e, item, key) {
      if(item.active) return;
      this.$analysis({
        category: 'rotate_animation_panel', 
        action: item.type ? 'click_anticlockwise' : 'click_clockwise', 
        label: item.type ? '旋转动画面板-逆时针' : '旋转动画面板-顺时针'
      })
      this.directionList.forEach((val, k) => {
        val.active = false;
        k === key && (val.active = true);
      })
      this.ccw = item.type;
      this.change = true;
    },
    async updateEffect(cancel) {
      if (!(this.change && !cancel) && !(cancel && this.hasWhirl)) return;
      this.change = false;
      let code = this.sprite.effect.code
      if(this.isSpecialEffect(code)) {
        code = 'FadeIn'
      }
      this.sprite.updateEffect({
        code: code,
        entranceAnim:{
          start: this.sprite.effect.entranceAnim.start,
          end: this.sprite.effect.entranceAnim.end
        },
        pathAnim: null,
        stayAnim: cancel ? {type: 'None'} : {
          type: 'Whirl',
          position: Object.assign({}, this.position),
          speed: this.speed,
          ccw: this.ccw
        }
      }, true).then(() => {
        this.$bus.emit('updateEffect_vue', {
          sprite: this.sprite,
          effect: this.sprite.effect || {},
          type: 'path'
        });
        this.sprite.changeStyle()
      })
    },
    playStayAnim() {
      this.updateEffect().then(() => {
        this.spriteBox = this.sprite;
        this.closePoint();
        this.$bus.emit('preview_callback', {
          type: 'play',
          source: 'whirl',
          startNode: this.sprite.effect.entranceAnim.end / 1000,
          stopNode: this.sprite.effect.exitAnim.start / 1000 - 0.02,
          spriteBox: this.spriteBox
        })
        this.$bus.emit('FeaturesPop_close_vue', {type: 3});
        this.$analysis({category:'rotate_animation_panel', action:'click_preview_animation', label:'旋转动画面板-预览动画'})
      })
    },
    cancleStayAnim() {
      this.updateEffect(true)
      this.closePoint();
      this.$bus.emit('cancleStayAnim')
      this.$analysis({category:'rotate_animation_panel', action:'click_delete_animation', label:'旋转动画面板-删除动画'})
    },
    stopDocument(e){
      e.stopPropagation();
    },
    closePoint(bol) {
      bol && this.updateEffect();
      this.isShow = false;
      this.sprite.action = null;
      this.$store.commit('toggle_isPreventDefault', true);
      this.$bus.emit('take_points', {type: 'close'})
    },
    _undoRedoHandle(data) {
      if(this.isShow && data.type === 'updateSpriteEffect') {
        this.initData()
      }
    },
    _outputPoints(data) {
      this.position.top = data.top;
      this.position.left = data.left;
      this.change = true;
    },
    isDrawEffect (code) {
      return /^(?:draw|hand|write)$/i.test('' + code);
    },
    isAppearEffect (code) {
      return /^(?:appear|type|bounce|roll)$/i.test('' + code);
    },
    isSpecialEffect (code) {
      return this.isDrawEffect(code) || this.isAppearEffect(code);
    }
  },
  directives: {
    dragHandle(el, binding, vnode) {
      let _this = vnode.context,
          now = 0,
          mousemove = null,
          mouseup = null,
          disx = 0;

      mousemove = (e) => {
        let pre = Math.round((disx - e.pageX) / 180 * 10) * .25;
        _this.speed =  (now - pre) < _this.speedRange[0] ? _this.speedRange[0] : (now - pre) > _this.speedRange[1] ? _this.speedRange[1] : now - pre;
      }
      mouseup = (e) => {
        document.removeEventListener('mousemove',mousemove);
        document.removeEventListener('mouseup',mouseup);
        _this.dragHandle = false;
        _this.dragMouseup();
        now = 0;
      }

      el.onmousedown = (e) =>{
        e.preventDefault();
        e.stopPropagation();

        _this.dragHandle = true;
        now = _this.speed;
        disx = e.pageX;

        document.addEventListener('mousemove', mousemove);
        document.addEventListener('mouseup', mouseup);
      }
    }
  },
  beforeDestroy () {
    this.$bus.off('effectSetting.whirl')
    this.$bus.off('undoRedoHandle', this._undoRedoHandle)
    this.$bus.off('output_points', this._outputPoints)
  }
}
</script>

<style lang="scss" scoped>
.setting-whirl {
  padding: 16px 15px;
  text-align: left;
  font-size: 15px;
}

.footer-play {
  margin: 0px auto 15px;
  padding-top: 22px;
  border-top: 1px solid #eee;
  width: 100%;
  display: flex;
  justify-content: space-between;
  div {
    width: 110px;
    height: 36px;
    background-color: #F0F0F8;
    text-align: center;
    line-height: 36px;
    border-radius: 3px;
    cursor: pointer;
    &:hover{
      background: #d9ddea;
    }

    i {
      display: inline-block;
      position: relative;
      top: 2px;
      width: 15px;
      height: 15px;
      margin-right: 8px;
    }

    .preview-play {
      background: url('../../../../static/svg/preview-play.svg') no-repeat;
    }
    .delete-stay {
      background: url('../../../../static/svg/delete.svg') no-repeat;
    }
  }
}

.direction {
  &__title {
    margin: 12px 0;
  }

  .radios__list {
    display: flex;
    align-items: center;
  }
  .radios__item {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:first-child {
      margin-right: 30px;
    }

    &>i {
      width: 16px;
      height: 16px;
      border-radius: 16px;
      border: solid 1px #474260;
    }
    &>span {
      padding-left: 5px;
    }

    &.active>i {
      background-color: #474260;
      box-shadow: 0 0 0 3px #ffffff inset;
    }
  }
}

.speed {
  margin-top: 20px;

  &__content {
    margin: 16px auto;
    text-align: center;
  }
}

.slider {
  width: 100%;
  display: flex;
  justify-content: space-between;

  div {
    font-size: 12px;
  }
}

.rc-slider-rail {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 6px;
  border: 2px solid #d9ddea;
  border-top: none;
}

.content-box {
  border-left: 2px solid #d9ddea;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 2px;
  position: absolute;
  top: 1px;
  margin-left: -1px;
}

.rc-slider {
  position: relative;
  height: 15px;
  width: 180px;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .rc-slider-handle {
    position: absolute;
    margin-left: -8px;
    margin-top: -5px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 13px solid #474261;
    cursor: -webkit-grab;
    cursor: grab;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
  }
}
.center {
  margin: 22px auto 20px;

  &__content {
    margin: 10px 0;
    position: relative;
    width: 220px;
    color: #9692A9;
    text-align: center;
    line-height: 24px;
  }
  .handle, .dom-content {
    position: absolute;
  }
  .handle {
    border: 1px dashed #ddd;
  }
  .little {
    position: absolute;
    width: 9px;
    height: 9px;
    background-color: red;
    border: 1px solid #fff;
    border-radius: 50%;
    cursor: pointer;
  }
}

.whirl-to-setting {
  width: 110px;
  height: 36px;
  background-color: #F0F0F8;
  text-align: center;
  line-height: 36px;
  border-radius: 3px;
  margin-bottom: 15px;
  cursor: pointer;

  &:hover {
    background-color: #5778fb;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/stayAnim/whirlSetting.vue